import { css } from '@emotion/react';
import { styled, Typography } from '@mui/joy';

export const CardHeaderTitle = styled(Typography)(
  () => css`
    font-weight: 700;
    font-size: 16px;
  `,
);
